import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import {
  mapRawToMeasurementRequest,
  mapRawToMeasurementRequestMinimal,
} from "@/mappers/measurementRequest";
import {
  CreateMeasurementRequest,
  RawMeasurementRequest,
  RawMeasurementRequestMinimal,
  UpdateMeasurementRequest,
} from "@/types/measurementRequest";
import {
  SWRApiError,
  UpdaterParams,
  swrConfigOptions,
  useDeleter,
  useFetcher,
  useMutater,
  useUpdater,
} from "./swr";

export const useMeasurementRequests = () => {
  const fetcher = useFetcher();

  const { data = [], ...rest } = useSWR<RawMeasurementRequestMinimal[], SWRApiError>(
    { url: "/measurement_requests" },
    fetcher,
    swrConfigOptions,
  );
  return { data: data.map(mapRawToMeasurementRequestMinimal), ...rest };
};

export const useMeasurementRequest = (id: number) => {
  const fetcher = useFetcher();

  const { data, ...rest } = useSWR<RawMeasurementRequest, SWRApiError>(
    { url: `/measurement_requests/${id}` },
    fetcher,
    swrConfigOptions,
  );
  return { data: data ? mapRawToMeasurementRequest(data) : null, ...rest };
};

export const useCreateMeasurementRequest = () => {
  const mutater = useMutater();

  return useSWRMutation<any, SWRApiError, string, CreateMeasurementRequest>(
    "/measurement_requests",
    mutater,
  );
};

export const useDeleteMeasurementRequest = () => {
  const deleter = useDeleter();

  return useSWRMutation<void, SWRApiError, string, { id: string }>(
    "/measurement_requests",
    deleter,
  );
};

export const useUpdateMeasurementRequest = () => {
  const updater = useUpdater();

  return useSWRMutation<void, SWRApiError, UpdaterParams, UpdateMeasurementRequest>(
    { url: "/measurement_requests" },
    updater,
  );
};

export const useMeasurementRequestsByMask = (maskId?: string) => {
  const fetcher = useFetcher();

  const { data = [], ...rest } = useSWR<RawMeasurementRequest[], SWRApiError>(
    maskId ? { url: `/measurement_requests/mask/${maskId}` } : null,
    fetcher,
    swrConfigOptions,
  );

  return { data: data.map(mapRawToMeasurementRequestMinimal), ...rest };
};
